"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomModelValue = void 0;
const getRandomModelValue = () => {
    const phenotypes = ['A', 'B', 'C', 'D', 'E'];
    const skinTones = ['1', '2', '3', '4', '5', '6', '7', '8'];
    const randomPhenotype = phenotypes[Math.floor(Math.random() * phenotypes.length)]; //NOSONAR
    const randomSkinTone = skinTones[Math.floor(Math.random() * skinTones.length)]; //NOSONAR
    const randomSex = Math.random() < 0.5 ? 'female' : 'male'; //NOSONAR
    return { randomPhenotype, randomSkinTone, randomSex };
};
exports.getRandomModelValue = getRandomModelValue;
